export default [
    's_airline_prefix',
    's_airline_name',
    's_airline_code',
    's_logo'
];